import React from 'react';
import ReactDOM from 'react-dom';

import { IconGlyphicon } from 'generics/icons';
import { classMixer } from 'generics/utils';

// LogStream.enable("GRAPHCONTROLLER");

export class PagerControl extends React.Component {
  renderPageButton(pageShift) {
    return (
      <li key={pageShift} className={(this.props.pageShift == pageShift) ? "active" : ""}>
        <a onClick={() => this.props.setPageShift(pageShift)} >
          {Math.floor(pageShift / this.props.pageSize) + 1}
        </a>
      </li>
    );
  }

  renderPageGap(key) {
    return (<li key={key} className="disabled"><a disabled >...</a></li>);
  }

  buildRange(start, stop) {
    let pager = [];
    for (let page = start; page <= stop; page++)
      pager.push(this.renderPageButton(page * this.props.pageSize));

    return pager;
  }

  buildPages() {
    const lastPage = (this.props.itemsCount > 0) ? Math.floor((this.props.itemsCount - 1) / this.props.pageSize) : 0;
    const curPage = (this.props.pageShift >= this.props.itemsCount) ?
      (lastPage) :
      Math.floor(this.props.pageShift / this.props.pageSize);

    if (lastPage < 11)
      return this.buildRange(0, lastPage);

    if (curPage < 6)
      return [
        ...this.buildRange(0, 7),
        this.renderPageGap("hiGap"),
        ...this.buildRange(lastPage - 1, lastPage)
      ];

    if ((lastPage - curPage) < 6)
      return [
        ...this.buildRange(0, 1),
        this.renderPageGap("lowGap"),
        ...this.buildRange(lastPage - 7, lastPage)
      ];

    return [
      ...this.buildRange(0, 1),
      this.renderPageGap("lowGap"),
      ...this.buildRange(curPage - 2, curPage + 2),
      this.renderPageGap("hiGap"),
      ...this.buildRange(lastPage - 1, lastPage)
    ];
  }

  render() {
    if ((!this.props.renderUseless) && (this.props.itemsCount < this.props.pageSize))
      return null;

    if ((!this.props.renderEmpty) && (this.props.itemsCount == 0))
      return null;

    return (
      <div className="text-center">
        <ul className="pagination">
          {this.buildPages()}
        </ul>
      </div>
    )
  }
}

export class SimplePagerView extends React.Component {
  render() {
    const { disableBack, disableForward, onClickBack, onClickForward, currentPosition,
      arrowsWithIndexes } = this.props;

    const classesBack = (disableBack && "invisible") || "";
    const classesFwd = (disableForward && "invisible") || "";

    const bwdText = (!!arrowsWithIndexes) && (!disableBack) && (currentPosition > 0) && ` ${currentPosition - 1}`;
    const fwdText = (!!arrowsWithIndexes) && (!disableForward) && (currentPosition >= 0) && `${currentPosition + 1} `;

    if (disableBack && disableForward)
      return null;

    return (
      <div className="ViewItemSearchPager">
        <ul className="pagination">
          <li className={classesBack}>
            <a disabled={disableBack} onClick={onClickBack}  >
              <IconGlyphicon type="chevron-left" /><span>{bwdText}</span>
            </a>
          </li>

          <li>
            <a disabled><span>{currentPosition}</span></a>
          </li>

          <li className={classesFwd}>
            <a disabled={disableForward} onClick={onClickForward}  >
              <span>{fwdText}</span><IconGlyphicon type="chevron-right" />
            </a>
          </li>
        </ul>
      </div>
    )
  }
}

export class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
    this.onRootRef = (r) => (this.dropdownRoot = r);
    this.handleOnTriggerClick = () => this.setState({ open: true });
    this.handleOnMenuClick = () => this.setState({ open: false });
    this.onDocumentClick = (event) => this.handleDocumentClick(event)
  }

  handleDocumentClick(event) {
    if (!this.dropdownRoot) return;
    const rootNode = ReactDOM.findDOMNode(this.dropdownRoot);
    if (!rootNode) return;
    if (!rootNode.contains(event.target)) {
      this.setState({ open: false });
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.onDocumentClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  render() {
    const rootClasses = classMixer("dropdown", this.state.open && "open",
      this.props.active && "active", this.props.disabled && "disabled",
      this.props.dropup && "dropup", this.props.mixClasses)

    const menuClasses = classMixer("dropdown-menu", this.props.alignAlt && "dropdown-menu-right");

    return (
      <div className={rootClasses} role="button" ref={this.onRootRef}>
        <a className="dropdown-toggle" title={this.props.title}
          onClick={this.handleOnTriggerClick}>
          {this.props.caption}&nbsp;
          <span className="caret" />
        </a>

        <ul className={menuClasses}
          onClick={this.handleOnMenuClick}>
          {this.props.children}
        </ul>
      </div>
    )
  }
};

export class DropdownAction extends React.Component {
  //  dropdown entry component
  render() {
    const rootClasses = classMixer(this.props.active && "active", this.props.disabled && "disabled",
      this.props.hidden && "hidden", this.props.mixClasses);

    const linkProps = {
      onClick: this.props.onClick,
      title: this.props.title,
      href: this.props.href,
      target: classMixer(this.props.newtab && "_blank"),
      rel: classMixer(this.props.newtab && "noopener noreferrer"),
    };

    return (
      <li className={rootClasses} role="button">
        <a {...linkProps}>
          {this.props.children}
        </a>
      </li>
    );
  }
};